var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle-button",style:({
    '--selected-bg': _vm.selectedBackgroundColour,
    '--selected-colour': _vm.selectedColour,
    '--bg': _vm.backgroundColour,
    '--colour': _vm.colour
  })},[_c('ul',{staticClass:"toggle-button__items"},_vm._l((_vm.items),function(item){return _c('li',{key:item,staticClass:"toggle-button__item",class:{'toggle-button__item--selected': _vm.selected === item},on:{"click":function($event){return _vm.select(item)}}},[_c('span',{staticClass:"toggle-button__item__label"},[_vm._v(_vm._s(item))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }